var image_upload_default = {
  "container": "urNtX",
  "disabled": "IbOik",
  "imageInput": "mRsOL",
  "overlay": "ZsJU6",
  "text": "_0K8-a",
  "shown": "syduI",
  "hide": "z9UdX",
  "spinner": "wv7K6",
  "spin": "mXl4G"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
